import { createId, titleFromPrompt } from '@/features/chat/chatIds'
import { resolveSendThreadId } from '../../resolveSendThreadId'

/** @param {{ currentId: string | null, forceNewThread: boolean, validIds: string[], setThreads: Function, setActiveThreadId: Function, trimmed: string, files?: unknown[] }} p */
export function ensureSendThreadId(p) {
  const { currentId, forceNewThread, validIds, setThreads, setActiveThreadId, trimmed, files } = p
  const { existingId, shouldCreate } = resolveSendThreadId({
    currentId,
    forceNewThread,
    validIds,
  })
  let threadId = existingId
  if (shouldCreate) {
    threadId = createId()
    const title = titleFromPrompt(trimmed || (files?.[0]?.name ?? 'Attachment'))
    setThreads((prev) => [{ id: threadId, title }, ...prev])
    setActiveThreadId(threadId)
  }
  return threadId
}
